import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const BROWARDHFABOND_LAYER_ID = 'browardHFABondLayer';

const ICONS = {
  'HFA Bond Assignment': require('../../../assets/house.png'),
};

const layerConfig = {
  title: 'HFA Bond Assignments',
};

function BrowardHFABondLayer() {
  const dispatch = useDispatch();
  const { browardHFABondLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardHFABondLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardHFABondLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDHFABOND_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardHFABondLayer.visible,
      opacity: browardHFABondLayer.opacity,

      pointType: 'icon',
      getIcon: (d) => {
        return {
          url: ICONS['HFA Bond Assignment'],
          width: 128,
          height: 128,
          anchorY: 128,
        };
      },
      getIconSize: () => 12,
      iconSizeUnits: 'pixels',
      iconSizeScale: 2,
      iconBillboard: true,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDHFABOND_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'HFA Bond Assignent Details',
              includeColumns: [
                'HFA_Bond_Project_Name',
                'HFA_Bond_Year',
                'HFA_Bond_Requested_Amount',
                'Project_Units',
                'Project_City',
              ],
            }),
          };
        }
      },
    });
  }
}

export default BrowardHFABondLayer;
